import  pink  from '@material-ui/core/colors/pink';
import  red  from '@material-ui/core/colors/red';
import merge from 'lodash/merge';
import { defaultTheme } from 'react-admin';

const myTheme = merge({}, defaultTheme, {
  transitions: {
    easeIn: 'cubic-bezier(2, 0, 1, 3)',
  },
  palette: {
    type: 'dark',
    primary: pink,
    error: red,
    contrastThreshold: 3,
    tonalOffset: 0.2,
  },
  typography: {
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Arial',
      'sans-serif',
    ].join(','),
  },
  overrides: {
    RaDatagrid: {
      headerCell: {
        fontWeight: 'bold',
        backgroundColor: '#b1bfd8',
        height: '20px',
        fontSize: '18px',
        boxShadow: '-webkit-box-shadow: 5px 5px 15px 5px #000000',
      },
    },
    RaCardHeader: {
      title: {
        fontWeight: 'bold',
        fontSize: '23px',
      },
    },
  },
});

export default myTheme;
